import { render } from "./DeleteAllLocations.vue?vue&type=template&id=18b1a668"
import script from "./DeleteAllLocations.vue?vue&type=script&lang=js"
export * from "./DeleteAllLocations.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__